import AppHeader from '../AppHeader'
export default {
  name: 'moral-check-list',
  created () {
    this.search()
  },
  data () {
    return {
      callbackFlag: false
    }
  },
  computed: {
    moralDetails () {
      return this.$store.getters.moralDetails
    },
    not_all_answer () {
      for (var index in this.moralDetails) {
        if (this.moralDetails[index].attributes['answer'] == null) {
          return true
          break;
        }
      }
      return false
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function () {
      var self = this
      var data = {
        'check_list': 'check_list'
      }
      var callback = function() {
        self.callbackFlag = true
        self.startSlide = self.moralLastCount
      }
      this.$store.dispatch('MORAL_GET',  {id: window.localStorage.getItem('user_id'), data: data, callback: callback})
    },
    goMoralSent: function () {
      var self = this
      var data = {
        'moral_id': this.moralDetails[0].attributes['moral-id'],
        'user_id': window.localStorage.getItem('user_id')
      }
      self.$store.dispatch('RESULT_SEND', {data: data})
      var callback = function() {
        self.$router.push({ path: '/moral_sent/'})
      }
      this.$store.dispatch('MORAL_END', {data: data, callback: callback})
    },
    getAnswer: function (answer) {
      if (answer == 'yes') {
        return '-yes'
      } else if (answer =='no'){
        return '-no'
      } else {
        return '-yet'
      }
    },
    goMoralCheck: function (index) {
      var target = index - 1
      this.$router.push({ path: '/moral_check/' + target})
    },
    notYet: function () {
      if (this.not_all_yes) {
        return 'margin-top'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/moral-check-list.js